import { render, staticRenderFns } from "./AssignPrivilege.vue?vue&type=template&id=2e5e1a18&"
import script from "./AssignPrivilege.vue?vue&type=script&lang=js&"
export * from "./AssignPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports